<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :actions="false"
  >
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
  </g-master>
</template>
<script>
  export default {
    data () {
      return {
        master: {
          valoresExpandidos: [
            {label: 'Año', column: 'year'},
            {label: 'Mes', column: 'mes'},
            {label: 'Periodo', column: 'period'}
          ],
          endpoint: 'overtime_hist',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            actions: false,
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'Empleado', dataIndex: 'empleado', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'fecha_inicio', sorter: true},
              {title: 'Fecha fin', dataIndex: 'fecha_fin', sorter: true},
              {title: 'Atributo 1', dataIndex: 'att1', sorter: true},
              {title: 'Atributo 2', dataIndex: 'att2', sorter: true},
              {title: 'ID concepto', dataIndex: 'coc', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'ID Shift setup', dataIndex: 'id_rh_t_shifts_setup', sorter: true},
              {title: '# de horas', dataIndex: 'n_hours', sorter: true},
              {title: 'Trabajo', dataIndex: 'work', sorter: true},
              {title: 'Creado el', dataIndex: 'created_at', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Actualizado el', dataIndex: 'updated_at', sorter: true},
              {title: 'Actualizado por', dataIndex: 'modified_by', sorter: true}
            ]
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/OvertimeHist.vue